import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
const TogglePill = t0 => {
  const $ = _c(16);
  const {
    "aria-label": ariaLabel,
    children,
    isDisabled,
    isSelected,
    onClick,
    variant
  } = t0;
  const t1 = !isSelected;
  const t2 = !isSelected && !isDisabled;
  const t3 = !isDisabled;
  const t4 = variant !== "ShopByHeaderSection";
  const t5 = variant === "ShopByHeaderSection";
  let t6;
  if ($[0] !== isDisabled || $[1] !== isSelected || $[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4 || $[6] !== t5) {
    t6 = classNames("text-sm font-bold rounded-[30px] inline-block mt-1 mb-1 ml-0 px-4 border-[1px] focus-visible:outline-offset-4", {
      "bg-white border-gray-light6 text-gray": t1,
      "bg-brand border-brand text-white": isSelected,
      "hover:bg-white hover:border-brand text-gray": t2,
      "cursor-pointer": t3,
      "cursor-not-allowed opacity-50": isDisabled,
      "mr-2 py-2.5": t4,
      "mr-1 py-[.7rem]": t5
    });
    $[0] = isDisabled;
    $[1] = isSelected;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isSelected) {
    t7 = !!isSelected && <VisuallyHidden>- selected</VisuallyHidden>;
    $[8] = isSelected;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== ariaLabel || $[11] !== children || $[12] !== onClick || $[13] !== t6 || $[14] !== t7) {
    t8 = <button aria-label={ariaLabel} className={t6} onClick={onClick} type="button">{children}{t7}</button>;
    $[10] = ariaLabel;
    $[11] = children;
    $[12] = onClick;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
TogglePill.propTypes = {
  'aria-label': PropTypes.string,
  children: PropTypes.node,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['ShopByHeaderSection'])
};
export default TogglePill;